/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_Feature_1Inputs */

const en_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited resumes`)
};

const de_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbegrenzte Lebensläufe`)
};

const fr_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV illimités`)
};

const es_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums ilimitados`)
};

const it_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum illimitati`)
};

const nl_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbeperkte CV's`)
};

const pl_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieograniczona liczba życiorysów`)
};

const fi_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajoittamaton määrä elämäkertoja`)
};

const da_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubegrænset antal CV'er`)
};

const sv_settings_student_feature_1 = /** @type {(inputs: Settings_Student_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obegränsat antal CV`)
};

/**
* | output |
* | --- |
* | "Unlimited resumes" |
*
* @param {Settings_Student_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_feature_1 = /** @type {((inputs?: Settings_Student_Feature_1Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_Feature_1Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_feature_1(inputs)
	if (locale === "fr") return fr_settings_student_feature_1(inputs)
	if (locale === "es") return es_settings_student_feature_1(inputs)
	if (locale === "it") return it_settings_student_feature_1(inputs)
	if (locale === "nl") return nl_settings_student_feature_1(inputs)
	if (locale === "pl") return pl_settings_student_feature_1(inputs)
	if (locale === "fi") return fi_settings_student_feature_1(inputs)
	if (locale === "da") return da_settings_student_feature_1(inputs)
	if (locale === "sv") return sv_settings_student_feature_1(inputs)
	return en_settings_student_feature_1(inputs)
});